module.exports = __webpack_public_path__ + "static/media/care.fbbe2b72.jpg";